var $ = require('jQuery');
var _ = require('underscore');
var Vue = require('vue');
var FieldCopier = require('../../lib/field-copier.js');
var TooltipAttacher = require('../../lib/tooltip-attacher.js');
var Slider = require('../../lib/slider.js');
var Multiselect = require('vue-bootstrap').Multiselect;
var FormDisabler = require('../../lib/form-disabler.js');

module.exports = function () {
  new Vue({
    el: '#category-selector',
    components: {
      'multiselect': Multiselect
    }
  });

  // Whenever a category selection is made (aka, all, or select), we need to show the appropriate container
  var categorySelection = function () {
    var value = $('input[name=categoryOption]:checked').val();

    if (value == 'select') {
      $('#categorySelectionContainer').show();
    } else {
      $('#categorySelectionContainer').hide();
    }
  };

  $('input[name=categoryOption]').change(categorySelection);
  categorySelection();

  /**
   * Alignment fields
   */
  var alignmentFields = function () {
    if ($('#allCategories').prop('checked')) {
      $('#fieldId option').show();
      return;
    }

    $('#fieldId option[data-categories]').each(function () {
      var categories = JSON.parse($(this).data('categories').clarify());
      var show = (categories === true);
      if (!show) {
        _.each(categories, function (category) {
          show = show || $('#categorySelectionContainer input[value=' + category + ']').prop('checked');
        });
      }

      $(this).toggle(show);

      if (!show && $('#fieldId').val() == $(this).val()) {
        $('#fieldId').val('');
      }
    });
  };
  alignmentFields();
  $('input[name=categoryOption], #categorySelectionContainer input[type=checkbox]').on('change', _.debounce(alignmentFields, 300));

  /**
   * Displays a setting to prevent scoring of empty fields if a field is selected. If the selected field is
   * conditional, displays a warning and checks the setting by default.
   */
  var fieldIdChange = function (fieldId, startingId) {
    $('.show-field-align').toggle(!!fieldId);

    if (!fieldId) {
      $('#conditional-alert').addClass('hidden');
      return;
    }

    var field = $('option[value=' + fieldId + ']');
    var ignoreEmpty = $('input[name="ignoreEmpty"]');

    if (field.data('content').clarify()) {
      ignoreEmpty.prop('checked', false);
      ignoreEmpty.prop('disabled', true);
    } else {
      ignoreEmpty.prop('disabled', false);
    }

    var conditional = field.data('conditional').clarify();

    if (conditional) {
      $('#conditional-alert').removeClass('hidden');
    } else {
      $('#conditional-alert').addClass('hidden');
    }

    if (conditional && fieldId !== startingId) {
      ignoreEmpty.prop('checked', true);
    }
  };

  let startingId = $('#fieldId').val();
  fieldIdChange(startingId, startingId);

  $('#fieldId').on('change', function () {
    let newId = $('#fieldId').val();
    fieldIdChange(newId, startingId);
    startingId = newId;
  });

  // Copy the label field value into the score title field when score title is currently empty.
  var fieldCopier = new FieldCopier();

  fieldCopier.setup('form.scoring-criteria-form-new', '#label', '#title');

  // Precision and increment settings toggle
  var togglePrecisionSettings = function (control) {
    if (control == 'input') {
      $('#scoring-precision').show();
      $('#scoring-increment').hide();
    } else {
      $('#scoring-precision').hide();
      $('#scoring-increment').show();
    }
  };

  togglePrecisionSettings($('[name="scoringControl"]:checked').val());
  $('[name="scoringControl"]').change(function () {
    togglePrecisionSettings($(this).val());
  });

  // Scoring criteria previews
  var form = $('form.scoring-criteria-form');
  var previewContainer = $('#scoringCriterionPreviewContainer');
  var slider = new Slider;
  var tooltipAttacher = new TooltipAttacher;
  var debouncedPreview;

  var initSlider = function () {
    slider.setup('[id^="slider-"]');
  };

  var initTooltips = function () {
    tooltipAttacher.attach('trigger-tooltip');
  };

  var showPreview = function () {
    $.ajax({
      type: 'GET',
      url: '/judging/scoring-criteria/preview',
      data: form.serialize()

    }).done(function (response) {
      if (response.success) {
        previewContainer.html(response.data);

        initSlider();
        initTooltips();

      } else {
        previewContainer.html(response.message);
      }
    });
  };

  debouncedPreview = _.debounce(showPreview, 500);

  form.find('input, textarea').on('keydown.preview', debouncedPreview);
  form.find('textarea.mde').on('change.preview', debouncedPreview);
  form.find('select, input[type="checkbox"], input[type="radio"]').on('change.preview', debouncedPreview);

  showPreview();

  (new FormDisabler()).disableForm($('.form-disabled'));
};
